<template>
    <span 
        class="text-primary ml-2"
        v-if="mostrarBotao"
    >    
        <i
            class="fa fa-pencil-square-o fa-lg icon-button"
            title="Alterar"
            @click.stop="$emit('abrirModalBoleto')"
        ></i>
    </span>
    
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus';

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        despesa: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        mostrarBotao() {
            return ((this.despesa.statusIdFat != 'F' || this.despesa.statusIdFat != 'Q')
                    && this.despesa.statusIdMov != 'F')
                && (this.AlteracaoPorRequisitanteFornecedor
                    || this.AlteracaoPorFinalizacao)

        },

        AlteracaoPorRequisitanteFornecedor() {
            return ( 
                (this.pagamento.status == pagamentoStatus.CRIADO
                    || this.pagamento.status == pagamentoStatus.REPROVADO)
                && ((this.$route.name == 'DespesasGerais_Requisitantes_Pagamentos_Detalhar'
                        && this.$temAcessoView('DESP-GERAIS-REQ-PAG-03'))
                    || (this.$route.name == 'DespesasGerais_Fornecedores_Pagamentos_Detalhar'
                        && this.$temAcessoView('DESP-GERAIS-FORN-PAG-03'))
                )
            )
        },

        AlteracaoPorFinalizacao()  {
            return (
                this.pagamento.status == pagamentoStatus.EM_ANALISE    
                && this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar'
                && this.$temAcessoView('DESP-GERAIS-FINAL-02')
            )
        }
    }    
}
</script>